import { Container, Typography } from "@mui/material";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material/node";
import React, { useState } from "react";
import { Fade } from 'react-awesome-reveal';
import { ExpandMoreRounded } from "@mui/icons-material";
import faq from '../../../data/faq.json'

export const Faq = (props) => {
  const [expanded, setExpanded] = useState('');

  const handleChange =
    (panel) => (event, newExpanded) => {
      setExpanded(newExpanded ? panel : false);
    };

  const generateAccordions = () => {
    return faq.map((faq) => (
      <Accordion
        expanded={expanded === faq.params.id}
        onChange={handleChange(faq.params.id)}
        key={faq.params.id}
        style={{
          backgroundColor: "hsl(14, 88%, 95%)",
          marginBottom: "10px",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}        
      >
        <AccordionSummary
          expandIcon={
            <ExpandMoreRounded style={{ color: "hsl(14, 88%, 65%)" }} />
          }
        >
          <Typography>{faq.params.question}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography id="answer" variant="body2">{faq.params.answer}</Typography>
        </AccordionDetails>
      </Accordion>
    ));
  };

  return (
    <Container id="faq" style={{
      scrollMarginTop: 70, height: "100%", marginTop: 50,
      alignItems: "center",
      flexDirection: "column", mt: 350, marginBottom: 50
    }} maxWidth="md" >
      <Fade bottom duration={1000}>
        <Typography
          variant="h2"
          component="h2"
          align="center"
          color="text.primary"
          gutterBottom
          sx={{marginBottom:5, fontWeight: 400}}
        >
          Frequently Asked Questions
        </Typography>
      </Fade>
      <Fade bottom duration={1000} >
        {generateAccordions()}
      </Fade>
    </Container>
  );
};